module.exports = __webpack_public_path__ + "media/images/front/pc/article/female-b2fec99ac83ffb555e662a0da297f0c9.png";